export const ExplainUIMixin = {
  data() {
    return {
      minDuration: 0,
      maxDuration: 0,
      pathDurations: [],
      bestPath: []
    };
  },
  methods: {
    isJsonObject(str) {
      try {
        return (typeof str === 'object');
      } catch (e) {
        return false;
      }
    },
    reformString(str){
      if(str.startsWith('"')){
        str = str.slice(1);
      }
      if(str.endsWith('"')){
        str = str.slice(0, -1);
      }
      return str
    },
    computeBestPath() {
      this.bestPath = [];
      this.pathDurations.forEach((d) => {
        if (d.duration) {
          if (this.computePathWidth(d.duration) >= 5) {
            this.bestPath.push(d.id);
          }
        }
      });
    },
    computePathWidth(p) {
      // the method scale the path between 1 and 10
      // xnormalized=(b−a)(x−min(x)/max(x)−min(x))+a

      if (!p || p < 0) {
        p = 0;
      }
      const result =
        ((10 - 1) * (p - this.minDuration)) /
          (this.maxDuration - this.minDuration) +
        1;

      return result;
    },
    getMinMax(jsonObject) {
      this.pathDurations = []
      let minMax = { min: 0, max: 0 };
      this.traverse(jsonObject, minMax);
      this.minDuration = minMax.min;
      this.maxDuration = minMax.max;
      this.computeBestPath();
    },
    traverse(jsonObject, minMax) {
      
      if (jsonObject !== null && typeof jsonObject == "object") {
        if(jsonObject.explainObject && !jsonObject.uid){
          jsonObject.uid = Math.random().toString(36).slice(2);
        }
        if (jsonObject && jsonObject.explainObject) {
          if (!this.pathDurations.some(e => e.id === jsonObject.id)) {
            this.pathDurations.push({
              id: jsonObject.uid,
              duration: jsonObject.explainObject.duration,
            });
          }
        }
        Object.entries(jsonObject).forEach(([key, value]) => {
          if (key == "duration" && typeof value == "number") {
            if (minMax.max < value) minMax.max = value;
            else if (minMax.min > value) minMax.min = value;
          }
          this.traverse(value, minMax);
        });
      }
    },
  },
};
